const characters = [
  {
    id: 0,
    name: "Niklaus",
    description: "Niklaus is the newest loyal knight of Queen Clarice's Order of Light. Also known as \"The Slayer of Light\", he delivers justice so that good can triumph.",
    icon: "/img/characters/niklaus-web-icon.png",
    portrait: "/img/characters/niklaus.png",
    difficulty: 1,
    characterType: "Melee",
    factionId: 1
  },
  {
    id: 1,
    name: "Thora",
    description: "Thora, daughter of Makani Varsha, the High Priest of the Sky, and Audra, the Goddess of Storms, was raised in faith and devotion. Proud of her divine origins, she quickly developed a gift for celestial magic.",
    icon: "/img/characters/lycia-web-icon.png",
    portrait: "/img/characters/lycia.png",
    difficulty: 1,
    characterType: "Mage / Range",
    factionId: 1
  },
  {
    id: 2,
    name: "Kimka",
    description: "Kimka was born in the slums of Polemos. Refusing to follow her mother's footsteps, she fled and learned to survive on her own.",
    icon: "/img/characters/kimka-web-icon.png",
    portrait: "/img/characters/kimka.png",
    difficulty: 1,
    characterType: "Range",
    factionId: 1
  },
  {
    id: 3,
    name: "Kemo",
    description: "Kemo has been confronted with loneliness since he was very young. His master taught him the voice of the breath.",
    icon: "/img/characters/kemo-web-icon.png",
    portrait: "/img/characters/kemo.png",
    difficulty: 3,
    characterType: "Melee",
    factionId: 1
  },
  {
    id: 4,
    name: "Elza",
    description: "Elza is the possessor of the corrupt spirit Korn.",
    icon: "/img/characters/elza-web-icon.png",
    portrait: "/img/characters/elza.png",
    difficulty: 2,
    characterType: "Mage / Range",
    factionId: 2
  },
  {
    id: 5,
    name: "Dimitri",
    description: "The only son in a family of 17 children, Dimitri is used to being the center of attention. Focused on building his physique, he set out to become a mercenary.",
    icon: "/img/characters/serbas-web-icon.png",
    portrait: "/img/characters/serbas.png",
    difficulty: 4,
    characterType: "Melee",
    factionId: 1
  },
  {
    id: 6,
    name: "Guldir",
    description: "Guldir was born in the province of Trabouc. Forged at the anvil, he mastered magic thanks to rigorous training.",
    icon: "/img/characters/guldir-web-icon.png",
    portrait: "/img/characters/guldir.png",
    difficulty: 2,
    characterType: "Melee",
    factionId: 1
  },
  {
    id: 7,
    name: "Jasper",
    description: "Brilliant mage searching for his missing twin Ivy. Fearless, competitive, and fueled by determination.",
    icon: "/img/characters/jasper-web-icon.png",
    portrait: "/img/characters/jasper.png",
    difficulty: 4,
    characterType: "Mage / Range",
    factionId: 1
  },
  {
    id: 8,
    name: "Kyren",
    description: "Kyren, a fearless warrior, battles valiantly for the honor and glory of his name.",
    icon: "/img/characters/kyren-web-icon.png",
    portrait: "/img/characters/kyren.png",
    difficulty: 5,
    characterType: "Melee",
    factionId: 2
  },
  {
    id: 9,
    name: "Mafalda",
    description: "A tactical ranged specialist skilled with explosives and area control.",
    icon: "/img/characters/mafalda.png",
    portrait: "/img/characters/mafalda.png",
    difficulty: 3,
    characterType: "Range",
    factionId: 1
  },
  {
    id: 10,
    name: "Asp",
    description: "Asp is a shadow assassin who strikes from above, chaining brutal aerial assaults.",
    icon: "/img/characters/asp-web-icon.png",
    portrait: "/img/characters/asp.png",
    difficulty: 4,
    characterType: "Melee / Assassin",
    factionId: 2
  },
  {
    id: 11,
    name: "Ganco",
    description: "Ganco is a toxic alchemist who overwhelms enemies with clouds of poison.",
    icon: "/img/characters/ganco-web-icon.png",
    portrait: "/img/characters/ganco.png",
    difficulty: 3,
    characterType: "Range / Control",
    factionId: 1
  }
];

const reincarnations = [
  { id: 0, name: "Flochon", description: "Flochon spirit, a fast and agile being. The lesson? Never trust appearances.", icon: "/img/characters/flochon.png", difficulty: 2, characterType: "Melee / Range" },
  { id: 1, name: "Golem", description: "Golem spirit, a patient and powerful being. The key to success is to wait for the right moment.", icon: "/img/characters/golem.png", difficulty: 5, characterType: "Melee" },
  { id: 3, name: "Woop", description: "Woop spirit, the forest is your ally.", icon: "/img/characters/woop.png", difficulty: 3, characterType: "Melee / Range" },
  { id: 5, name: "Ghoo", description: "Ghoo is the empty things you represent.", icon: "/img/characters/ghost.png", difficulty: 1, characterType: "Range" },
  { id: 6, name: "Diaby", description: "Diaby is the evil. We can't add more.", icon: "/img/characters/diaby.png", difficulty: 2, characterType: "Melee / Range" },
  { id: 7, name: "Woom", description: "Woom is a parasitic worm.", icon: "/img/characters/woom.png", difficulty: 4, characterType: "Range" },
  { id: 9, name: "Bok", description: "Bok, knowledge is a mouth full of BRBRBRBHJERBHRJH.", icon: "/img/characters/bok.png", difficulty: 1, characterType: "Melee" },
  { id: 10, name: "Slime", description: "Slime is happy happy happy!", icon: "/img/characters/slime.png", difficulty: 5, characterType: "Melee" }
];

const rawBonuses = [
  { id: 0, name: "Power Strike", description: "Increases all damage by 5%", type: "Attack", icon: "UI/spells/Skill_standart/skill_6" },
  { id: 1, name: "Healing Soul", description: "+1 Health point on taking soul", type: "Utility", icon: "UI/spells/Skill_standart/skill_127" },
  { id: 2, name: "Max Health Soul", description: "+0.02 Max Health point on taking soul", type: "Attack", icon: "UI/spells/Skill_standart/skill_130" },
  { id: 3, name: "Spell 1 Mastery", description: "Reduces Spell 1 cooldown by 20% per stack", type: "Utility", icon: "UI/spells/Skill_standart/skill_115" },
  { id: 4, name: "Quick Strikes", description: "Reduces auto attack delay by 20% per stack", type: "Attack", icon: "UI/spells/Skill_standart/skill_202" },
  { id: 5, name: "Spell 2 Mastery", description: "Reduces Spell 2 cooldown by 20% per stack", type: "Utility", icon: "UI/spells/Skill_standart/skill_115" },
  { id: 6, name: "Spell 3 Mastery", description: "Reduces Spell 3 cooldown by 20% per stack", type: "Utility", icon: "UI/spells/Skill_standart/skill_115" },
  { id: 7, name: "Spell 4 Mastery", description: "Reduces Spell 4 cooldown by 20% per stack", type: "Utility", icon: "UI/spells/Skill_standart/skill_115" },
  { id: 8, name: "Self Propulsion", description: "Increases self push distance by 20% per stack", type: "Utility", icon: "UI/spells/Skill_standart/skill_266" },
  { id: 9, name: "Shockwave Boost", description: "Increases target push distance by 20% per stack", type: "Utility", icon: "UI/spells/Skill_standart/skill_307" },
  { id: 10, name: "Stunning Presence", description: "Extends all stuns and crowd control by 20% per stack", type: "Utility", icon: "UI/spells/Skill_standart/skill_383" },
  { id: 11, name: "Accelerated Projectiles", description: "Increases projectile speed by 25% per stack", type: "Utility", icon: "UI/spells/Skill_standart/skill_318" },
  { id: 12, name: "Survivor's Pace", description: "Increases movement speed by 25% per stack", type: "Utility", icon: "UI/spells/Skill_standart/skill_408" }
];

const toBonusIconPath = (rawIcon) => {
  if (!rawIcon) return null;
  const parts = rawIcon.split("/");
  const fileName = parts[parts.length - 1];
  return `/img/bonus/${fileName}.png`;
};

const bonuses = rawBonuses.map((b) => ({
  ...b,
  iconPath: toBonusIconPath(b.icon)
}));

const objects = [
  { id: 0, name: "Default skin", description: "A magical elixir that restores health" },
  { id: 2, name: "Default skin - Kimka", description: "A magical elixir that restores health" },
  { id: 3, name: "Default skin - Kemo", description: "A magical elixir that restores health" },
  { id: 4, name: "Default skin - Elza", description: "A magical elixir that restores health" },
  { id: 5, name: "Default skin - Dimitri", description: "A magical elixir that restores health" },
  { id: 7, name: "Default skin - Jasper", description: "A magical elixir that restores health" },
  { id: 8, name: "Default skin - Kyren", description: "A magical elixir that restores health" },
  { id: 100, name: "Skin - Tenue de Niklaus de Dechys", description: "A sharp and deadly weapon" },
  { id: 101, name: "Skin - Tenue de Niklaus du Cercle de Rivandy", description: "A magical elixir that restores health" },
  { id: 6, name: "Skin - Default", description: "A magical elixir that restores health" },
  { id: 600, name: "Skin - Guldir Circle", description: "A sharp and deadly weapon" },
  { id: 601, name: "Skin - Guldir Dechys", description: "A magical elixir that restores health" },
  { id: 200, name: "Skin - Tenue de Kimka de Dechys", description: "A sharp and deadly weapon" },
  { id: 201, name: "Skin - Tenue de Kimka du Cercle de Rivandy", description: "A magical elixir that restores health" },
  { id: 300, name: "Skin - Tenue de Kemo de Dechys", description: "A sharp and deadly weapon" },
  { id: 301, name: "Skin - Tenue de Kemo du Cercle de Rivandy", description: "A magical elixir that restores health" },
  { id: 400, name: "Skin - Tenue de Elza de Dechys", description: "A sharp and deadly weapon" },
  { id: 401, name: "Skin - Tenue de Elza du Cercle de Rivandy", description: "A magical elixir that restores health" },
  { id: 500, name: "Skin - Tenue de Dimitri de Dechys", description: "A sharp and deadly weapon" },
  { id: 501, name: "Skin - Tenue de Dimitri du Cercle de Rivandy", description: "A magical elixir that restores health" },
  { id: 700, name: "Skin - Tenue de Jasper de Dechys", description: "A sharp and deadly weapon" },
  { id: 701, name: "Skin - Tenue de Jasper du Cercle de Rivandy", description: "A magical elixir that restores health" },
  { id: 800, name: "Skin - Tenue de Kyren de Dechys", description: "A sharp and deadly weapon" },
  { id: 801, name: "Skin - Tenue de Kyren du Cercle de Rivandy", description: "A magical elixir that restores health" },
  { id: 1, name: "Default skin - Lycia", description: "A magical elixir that restores health" },
  { id: 50, name: "Skin 1 - Lycia", description: "A sharp and deadly weapon" },
  { id: 51, name: "Skin 2 - Lycia", description: "An enchanted armor that provides protection" },
  { id: 52, name: "Skin 3 - Lycia", description: "A mystical robe that enhances magical power" },
  { id: 202, name: "Skin 3 - Kimka", description: "An agile and stealthy outfit, perfect for survival" },
  { id: 302, name: "Skin 3 - Kemo", description: "A robe infused with the breath of the ancients, enhancing mystical abilities" }
];

const factions = [
  { id: 1, title: "Rivandy Circle", description: "Benevolent guardians of innocent souls, preserving balance.", color: "#C59500" },
  { id: 2, title: "Dechys", description: "Corrupted beings driven by an insatiable thirst for power.", color: "#DB0003" }
];

const modes = [
  { id: 3, title: "Polemos", description: "Challenge others to survive or increase your spiritual power.", color: "#D44300" },
  { id: 4, title: "Survivor", description: "The Survivor Mode.", color: "#f2c6b2" }
];

const toMap = (items) => items.reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {});

export const charactersById = toMap(characters);
export const reincarnationsById = toMap(reincarnations);
export const bonusesById = toMap(bonuses);
export const objectsById = toMap(objects);
export const factionsById = toMap(factions);
export const modesById = toMap(modes);
export const modesByTitle = modes.reduce((acc, m) => {
  acc[(m.title || "").toLowerCase()] = m;
  return acc;
}, {});

export const rewardTypes = {
  0: "Item",
  1: "Spirit",
  2: "Currency",
  3: "Booster",
  4: "Skin"
};

export function resolveCharacter(id) {
  return charactersById[id] || null;
}

export function resolveReincarnation(id) {
  return reincarnationsById[id] || null;
}

export function resolveBonus(id) {
  return bonusesById[id] || null;
}

export function resolveFaction(id) {
  return factionsById[id] || null;
}

export function resolveRewardLabel(reward) {
  if (!reward) return "";
  if (reward.rewardType in rewardTypes) {
    console.log(reward);
    const mode = reincarnationsById[reward.rewardId];
    if (mode) {
      return mode.name;
    }
  }
  return `#${reward.rewardId}`.trim();
}


